import type { HTMLAttributes } from 'react';
import { createPortal } from 'react-dom';

import { Text } from '@/components/Typography/Text';
import { cn } from '@/lib/cn';

import { Loader } from './Loader';
import { Overlay } from './Overlay';

interface FullScreenOverlayProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  /** ローダーのサイズ。デフォルトは "size-10" */
  loaderSize?: string;
  message?: string;
}

/**
 * 画面全体に対してオーバーレイとローディング表示を行うコンポーネント。
 * position: fixed で実装されており、すべての要素の上に表示されます。
 * Portal を使用して document.body 直下にレンダリングし、
 * 他の DOM 操作（PDF エクスポート等）からアニメーションを分離します。
 */
export const FullScreenOverlay = ({
  className,
  loaderSize = 'size-10',
  message,
  ...props
}: FullScreenOverlayProps) =>
  // NOTE: Radixのpopoverのz-indexが50のため、100を指定
  createPortal(
    <Overlay className={cn('fixed inset-0 z-100', className)} {...props}>
      <div className="flex flex-col items-center gap-4">
        <Loader size={loaderSize} />
        {message && (
          <Text variant="labelLarge" className="text-muted-foreground">
            {message}
          </Text>
        )}
      </div>
    </Overlay>,
    document.body,
  );
